module.exports = __webpack_public_path__ + "img/nav-header-mobile-jewelry.3e35d4f.jpg";